import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useRouter } from "next/router";
import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";

function SignUpSuccessModal() {
  const router = useRouter();
  const [open, setOpen] = useState(!!router.query.success);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{
        className: "w-full h-full sm:h-auto sm:w-auto m-0 sm:mx-auto sm:my-8",
      }}
    >
      <DialogTitle className="text-center">
        <Link href={"/"}>
          <Image alt={""} src={"/root/Explore_BC_logo_header.png"} width={210} height={49} />
        </Link>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <h1 className={"text-black-happyway font-roboto text-2-5xl font-semibold mb-2"}>Welcome to ExploreBC!</h1>
        </DialogContentText>
        <DialogContentText>
          <h2 className={"text-black-happyway font-roboto text-xl font-semibold mb-2"}>Registration Complete!</h2>
        </DialogContentText>
        <DialogContentText className="mt-4">
          If you have not received the verification email in your inbox, please check your junk or spam mail folder as
          it may have been filtered there.
        </DialogContentText>
      </DialogContent>
      <DialogActions className="justify-center p-4">
        <Button className="rounded-[40px]" variant="contained" onClick={handleClose}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SignUpSuccessModal;
